import styled from 'styled-components'

export default styled.ul`
  display: grid;
  gap: 10px;
  list-style: none;
  justify-items: center;
  padding: 0;
`
